import type { Locale } from 'date-fns';
import { nl } from 'date-fns/locale/nl';
import { enUS } from 'date-fns/locale/en-US';
import { pl } from 'date-fns/locale/pl';
import { ro } from 'date-fns/locale/ro';
import { bg } from 'date-fns/locale/bg';
import { hu } from 'date-fns/locale/hu';
import { de } from 'date-fns/locale/de';
import { es } from 'date-fns/locale/es';
import { pt } from 'date-fns/locale/pt';
import { uk } from 'date-fns/locale/uk';
import { tr } from 'date-fns/locale/tr';
import { lt } from 'date-fns/locale/lt';
import { cs } from 'date-fns/locale/cs';
import { sk } from 'date-fns/locale/sk';

const localeMap: Record<string, Locale> = {
  nl,
  en: enUS,
  pl,
  ro,
  bg,
  hu,
  de,
  es,
  pt,
  uk,
  tr,
  lt,
  cs,
  sk,
};

export function getDateFnsLocale(lang: string): Locale {
  return localeMap[lang] ?? nl;
}
